import * as RadioGroup from '@givebutter/primitives/radio-group';
import { useCustomField } from 'components/custom-fields/CustomFieldForm';
import { toFriendlyType } from 'components/custom-fields/helpers';
import * as Form from 'components/form';
import { twJoin } from 'tailwind-merge';

const CustomFieldTextForm = () => {
    const methods = Form.useGivebutterFormContext();
    const { control, getValues } = methods;
    const { customField, getFormFieldPath } = useCustomField();

    const type = getValues(getFormFieldPath('type'));
    if (toFriendlyType(type) !== 'text') {
        return null;
    }

    const isEditing = Boolean(customField);
    const canChangeType = !isEditing || customField?.type === 'text';

    return (
        <div className={twJoin('flex flex-col gap-y-3', !canChangeType && 'opacity-50')}>
            <Form.Label name={getFormFieldPath('type')} className="text-base">
                Type
            </Form.Label>
            <Form.UseFormRadioGroup
                control={control}
                name={getFormFieldPath('type')}
                disabled={!canChangeType}
            >
                <RadioGroup.ItemContainer>
                    <RadioGroup.Item value={'text'}>
                        <RadioGroup.Indicator />
                    </RadioGroup.Item>
                    <div>
                        <Form.Label
                            name={getFormFieldPath('type')}
                            htmlFor={'text'}
                            className={twJoin(
                                'flex flex-col leading-none',
                                canChangeType ? 'cursor-pointer' : 'cursor-not-allowed',
                            )}
                        >
                            <span>Text</span>
                            <span className={'text-sm font-normal leading-loose text-gray-600'}>
                                Single line, short answer text box.
                            </span>
                        </Form.Label>
                    </div>
                </RadioGroup.ItemContainer>

                <RadioGroup.ItemContainer>
                    <RadioGroup.Item value={'textarea'}>
                        <RadioGroup.Indicator />
                    </RadioGroup.Item>
                    <div>
                        <Form.Label
                            name={getFormFieldPath('type')}
                            htmlFor={'textarea'}
                            className={twJoin(
                                'flex flex-col leading-none',
                                canChangeType ? 'cursor-pointer' : 'cursor-not-allowed',
                            )}
                        >
                            <span>Paragraph</span>
                            <span className={'text-sm font-normal leading-loose text-gray-600'}>
                                Long form paragraph field.
                            </span>
                        </Form.Label>
                    </div>
                </RadioGroup.ItemContainer>
            </Form.UseFormRadioGroup>
            <Form.UseFormError name={getFormFieldPath('type')} />
        </div>
    );
};

const Text = CustomFieldTextForm;

export {
    CustomFieldTextForm,
    //
    Text,
};
